export const getPageFromNext = (next: string) => {
	if (next) {
		const url = new URL(next);
		const page = url.searchParams.get('page');
		if (page) {
			return parseInt(page);
		}

		return false;
	}
};
